module.exports = __webpack_public_path__ + "img/20210430_111133.0f567afc.jpg";